import React, { ReactElement } from "react";
import { Container } from "react-bootstrap";

import styled from "styled-components";

import Info from "./Info";
import ForgotPasswordForm from "./ForgotPasswordForm";

export default function ForgotPassword(): ReactElement {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "red",
        minWidth: "100vw",
        minHeight: "100vh",
      }}
    >
      <InfoDiv>
        <Info />
        <ForgotPasswordForm />
      </InfoDiv>
    </div>
  );
}

const InfoDiv = styled.div`
  display: flex;
  width: 100vw;
`;
